import { Image as Image_ } from "@chakra-ui/react"
import { forwardRef } from "react"
export const Image = forwardRef(({...props}, ref) => {
    return <Image_ ref={ref} {...props}>{props?.children}</Image_>
});